import React, {useEffect, useState} from 'react'
import {AutoComplete, Button, DatePicker, Form, Input, InputNumber, message, Modal} from "antd";
import {getAllRecipes, recipeStockList} from "../../services/serviceRecipe";
import {getAllCustomer} from "../../services/serviceCustomer";
import {createAll} from "../../services/serviceProduction";
import moment from "moment";
import {getAllProductionLine} from "../../services/serviceProductionLine";
import ProductionStockWarehouse from "./ProductionStockWarehouse";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const {Option} = AutoComplete
const { TextArea } = Input
const dateFormat = 'DD/MM/YYYY'

const ProductionUpdateModal = ({record, show, modalCloser}) => {
    const [form] = Form.useForm()
    const [customers, setCustomers] = useState([])
    const [recipes, setRecipes] = useState([])
    const [selectedRecipeItems, setSelectedRecipeItems] = useState([])
    const [selectedRecipe, setSelectedRecipe] = useState()
    const [selectedCustomer, setSelectedCustomer] = useState()
    const [productionLines, setProductionLines] = useState([])
    const [selectedProdLine, setSelectedProdLine] = useState()
    const [productionStocks, setProductionStocks] = useState()
    const [bulkList, setBulkList] = useState([])
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        getAllRecipes()
            .then(({data}) => {
                const allRecipes = data.map(item => {
                    return {
                        value: item.id,
                        text: item.name
                    }
                })
                setRecipes(allRecipes)
            })

        recipeStockList(record.production.recipe.id)
            .then(({data}) => setSelectedRecipeItems(data))

        getAllCustomer()
            .then(({data}) => {
                let customerData = []
                data.forEach(item => {
                    let customerItem = {
                        text: `${item.name}`,
                        value: item.id
                    }
                    customerData.push(customerItem)
                })
                setCustomers(customerData)
            })

        getAllProductionLine()
            .then(({data}) => {
                let productionLineData = []
                data.forEach(item => {
                    let prodItem = {
                        text: item.name,
                        value: item.id
                    }
                    productionLineData.push(prodItem)
                })
                setProductionLines(productionLineData)
            })

        const productionStocks = getProductionStocks()
        const warehouseStockInfo = productionStocks.map(item => {
            return {
                stock: {
                    id: item.stock.id
                },
                warehouse: {
                    id: item.warehouse.id
                }
            }
        })

        setBulkList(warehouseStockInfo)
        setProductionStocks(productionStocks)
        setSelectedProdLine(record.production.productionLine.id)
        setSelectedCustomer(record.production.customer.id)
        setSelectedRecipe(record.production.recipe.id)
    },[record])

    const getProductionStocks = () => record.productionStocks
    const handleCustomerChange = (v, o) => setSelectedCustomer(o.key)
    const handleProdChange = (v, o) => setSelectedProdLine(o.key)
    const handleRecipeChange = (v, {key}) => {
        if (key && selectedRecipe && selectedRecipe !== key) {
            recipeStockList(key)
                .then(({data}) => {
                    setBulkList([])
                    setProductionStocks(data)
                    setSelectedRecipe(key)
                })
        }
    }
    const handleBulkList = (stockId, warehouseId) => {
        const mockList = bulkList
        const matchedItem = mockList.find(item => item.stock.id === stockId)

        if (matchedItem && warehouseId) {
            matchedItem.warehouse.id = warehouseId
            setBulkList([...mockList])
            return
        }

        if (matchedItem && !warehouseId) {
            mockList.splice(mockList.indexOf(matchedItem), 1)
            setBulkList([...mockList])
            return
        }

        mockList.push({
            stock: {
                id: stockId
            },
            warehouse: {
                id: warehouseId
            }
        })
        setBulkList([...mockList])
    }
    const handleSubmit = () => {
        enterLoadingState(setLoadings)
        if (bulkList.length) {
            const {
                productionNotes,
                productionEndDate,
                productionStartDate,
                productionQuantity
            } = form.getFieldsValue()

            let requestObj = {
                customer: {id: selectedCustomer},
                endDate: productionEndDate._d,
                productionId: record.production.id,
                note: productionNotes,
                productionLine: selectedProdLine === null ? null : {id: selectedProdLine},
                productionStockDTOS: bulkList,
                quantity: productionQuantity,
                recipe: {id: selectedRecipe},
                startDate: productionStartDate._d,
            }

            createAll(requestObj)
                .then(() => {
                    exitLoadingState(setLoadings)
                    modalCloser()
                })
                .catch(() => exitLoadingState(setLoadings))
        }
        message.warning('Seçtiğiniz Reçetenin Kalemlerine Ait Stok Bilgisi Bulunamadı')
    }

    return(
        <React.Fragment>
            <Modal
                title={'Üretim Emri Güncelle'}
                closable={false}
                open={show}
                footer={[
                    <Button
                        key={'SubmitButton'}
                        type={'primary'}
                        loading={loadings[0]}
                        onClick={() => form.submit()}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={modalCloser}>
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    onFinish={handleSubmit}
                    labelCol={{span:6}}
                    wrapperCol={{span: 18}}
                    labelAlign={'left'}
                >
                    <Form.Item
                        label={'Reçete'}
                        name={'productionRecipe'}
                        initialValue={record.production.recipe.name}
                    >
                        <AutoComplete
                            style={{minWidth: '75px'}}
                            onChange={handleRecipeChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {recipes.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Müşteri'}
                        name={'productionCustomer'}
                        initialValue={record.production.customer.name}
                    >
                        <AutoComplete
                            style={{minWidth: '75px'}}
                            onChange={handleCustomerChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {customers.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    {
                        selectedRecipeItems.length ?
                            <>
                            {
                                productionStocks.map((item, index) => {
                                    const stock = item.stock || item
                                    return (
                                        <ProductionStockWarehouse
                                            key={index}
                                            stockLabel = {`${stock.code} - ${stock.name}`}
                                            productionItem ={item}
                                            stockId={stock.id}
                                            formInstance={form}
                                            handler={handleBulkList}
                                        />
                                    )
                                })
                            }
                            </>
                        : null
                    }
                    <Form.Item
                        label={'Miktar'}
                        name={'productionQuantity'}
                        initialValue={record.production.quantity}
                    >
                        <InputNumber min={0.1} step={0.1} />
                    </Form.Item>
                    <Form.Item
                        label={'Başlangıç Tarihi'}
                        name={'productionStartDate'}
                        initialValue={moment(record.production.startDate, 'YYYY-MM-DD')}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}

                    >
                        <DatePicker format={dateFormat} placeholder={'Tarih Seçiniz'}/>
                    </Form.Item>
                    <Form.Item
                        label={'Bitiş Tarihi'}
                        name={'productionEndDate'}
                        initialValue={moment(record.production.endDate, 'YYYY-MM-DD')}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}

                    >
                        <DatePicker format={dateFormat} placeholder={'Tarih Seçiniz'}/>
                    </Form.Item>
                    <Form.Item
                        label={'Üretim Hattı'}
                        name={'productionLine'}
                        initialValue={record.production.productionLine.name}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'},
                            () => ({
                                validator(rule, value) {
                                    let hasValue = productionLines.filter(production => production.text.toLowerCase() === value.toLowerCase())
                                    if (value && hasValue.length > 0) {
                                        handleProdChange(true, {key: hasValue[0].value})
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Lütfen Geçerli Bir Değer Seçiniz');
                                },
                            }),
                        ]}
                    >
                        <AutoComplete
                            style={{minWidth: '75px'}}
                            onChange={handleProdChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {productionLines.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Üretim Notu'}
                        name={'productionNotes'}
                        initialValue={record.production.note}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default ProductionUpdateModal